import { useCreateLoyaltyConfigMutation } from '@/services/innovorder/modules/modules.endpoints';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';

const useCreateZerosixConfig = () => {
    const { restaurantId } = useParams<{ restaurantId: string }>();
    const [createConfig, { isLoading: isCreating }] = useCreateLoyaltyConfigMutation();
    const {
        control,
        handleSubmit,
        reset,
        formState: { isDirty },
    } = useForm<{ zerosixApiKey: string }>({
        mode: 'all',
    });

    const onSubmit = (data: { zerosixApiKey: string }) => {
        createConfig({
            restaurantId: Number(restaurantId),
            apiKey: data.zerosixApiKey,
            provider: 'zerosix',
        });
        reset();
    };
    return { createConfig, isCreating, onSubmit, control, handleSubmit, isDirty };
};

export default useCreateZerosixConfig;
